













import { NoteApi } from "../../api/NoteApi";

export default {
    name: "NoteListButton",
    data() {
        return {
            notesCount: 0,
            NoteApi: new NoteApi(),
        };
    },
    created() {
        this.refreshCount();
    },
    methods: {
        toggleList: function () {
            this.$emit("toggle-list", true);
        },
        refreshCount: function () {
            let self = this;
            self.NoteApi.getCount({}).then(function (response) {
                self.notesCount = response;
            });
        },
    },
};
